import { PrivacyService } from "../services/PrivacyPolicy";

export const GetPrivacy = async () => {
  const data = await PrivacyService.GetPrivacy();
  return data;
};
